import React from "react";

import { Form, Icon, Option, Select, Typography } from "components";

export const FieldVerificationForm = ({ verified, name, onChange, disabled }) => (
  <Form name={name}>
    <Select name="verification-status" disabled={disabled} initialValue={verified} onChange={onChange} className="verification-select">
      <Option value={true}>
        <Typography variant="paragraph-m" className="approved">
          <Icon iconName="tabler/circle-check" size="s" className="icon inline margin-right-25" />
          approved
        </Typography>
      </Option>
      <Option value={false}>
        <Typography variant="paragraph-m" className="rejected">
          <Icon iconName="tabler/circle-x" size="s" className="icon inline margin-right-25" />
          rejected
        </Typography>
      </Option>
      <Option value={null}>
        <Typography variant="paragraph-m">
          <Icon iconName="tabler/help" size="s" className="icon inline margin-right-25" />
          not verified
        </Typography>
      </Option>
    </Select>
  </Form>
);
